module.exports = __webpack_public_path__ + "img/15.24cf7efe.jpg";